import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../../common/buttons/button-style/button-style.component';
import { DfEventService } from '@df/core/service/df-event';
import { Router, RouterModule } from '@angular/router';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'minibasket-submit',
    templateUrl: 'minibasket-submit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, RouterModule, ButtonStyleComponent]
})
export class MinibasketSubmitComponent extends UiComponent {
    private router = inject(Router);
    private readonly dfEventService = inject(DfEventService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(
            this.router.events.subscribe(() => {
                this.detectChanges();
            })
        );
    }

    protected get url(): string {
        return this.isCart ? '/checkout' : '/cart';
    }

    private get isCart(): boolean {
        return this.router.url === '/cart';
    }

    protected track() {
        this.dfEventService.dispatch({
            id: 'dfGtmCustomEvent',
            data: {
                name: 'checkout_click',
                data: {
                    location: 'minibasket'
                }
            }
        });
    }
}
